import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DashboardSectionOptions} from '../../../../dashboard/dashboard-section/dashboard-section-options';
import {Subscription} from 'rxjs';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-transport-intervention-time-widget',
  templateUrl: './transport-intervention-time-widget.component.html',
  styleUrls: ['./transport-intervention-time-widget.component.scss']
})
export class TransportInterventionTimeWidgetComponent implements OnInit, OnDestroy {

  @Input()
  dataSource: any;
  options: {
    customizeText: (arg) => string;
    unit: string;
    color: string;
    text: string;
    valueField: string;
    aggregationMethod: string
  };
  aggregationInterval = 'hour';
  private datePipeFormat = 'short';
  private sub: Subscription;

  constructor(private sectionOptions: DashboardSectionOptions, private datePipe: DatePipe) {
    this.options = {
      text: 'Distances',
      valueField: 'length_in_km',
      unit: 'Km',
      aggregationMethod: 'avg',
      color: '#e91e63',
      customizeText: (arg) => {
        return arg.value.toFixed(2) + ' km';
      }
    };
    this.customizeTooltip = this.customizeTooltip.bind(this);
  }

  ngOnInit(): void {
    this.sub = this.sectionOptions.change$.subscribe((d) => {
      switch (d.name) {
        case 'valueField':
          this.options = d.data;
          break;
        case 'aggregationInterval':
          this.datePipeFormat = d.data.aggregationInterval === 'hour' ? 'short' : 'shortDate';
          this.aggregationInterval = d.data.aggregationInterval;
          break;
      }
    });
  }

  customizeTooltip(arg: any) {
    const aggregationInfo = arg.point.aggregationInfo;
    const start = aggregationInfo && aggregationInfo.intervalStart;
    const end = aggregationInfo && aggregationInfo.intervalEnd;

    return {
      text: (!aggregationInfo ?
        'Date: ' + this.datePipe.transform(arg.argument, this.datePipeFormat) :
        this.datePipe.transform(start, this.datePipeFormat) + ' - ' + this.datePipe.transform(end, this.datePipeFormat))
    };
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
